// @ts-nocheck
/* eslint-disable */
import { node } from "~/util/dom";
import { addListener, removeListeners } from "~/lib/signals";
import ContentFull from "~/content.full";
import { _ } from "~/i18n";
import createMobileAppButtons from "~/ui/mobileappbuttons";
import { CONFIG } from "~/config";
import Canonical from "~/canonical";

const SECTION_INDEXES_ORDER = [
	15, 19, 20, 21, 17, 22, 23, 6, 7, 16
];

export default function MobilePromo() {
	return class extends ContentFull {
		constructor(){
			super();

			this._contentName = "mobile-promo";
			this._dom = {
				container: node("div", {className:"mobile-promo"}),
			};

			this._hash = null; /* captcha hash */
			this._sendBtn = null;

			this._sc = [];
			this._sc.push(addListener(this, "width-change-start", "_widthChangeStart"));

			this._buildCloseButton();
		};

		destroy(){
			removeListeners(this._sc);

			this._setErrorMessage("","phone");
			this._setErrorMessage("","captcha");
			this._clear();

			super.destroy();
		};

		getContainer(){
			return this._dom.container;
		}

		activate() {
			if (this.isActive()) { return this; }

			!this._sendBtn && this._build();

			super.activate();

			Mapy.SEO.set(_("mobilePromo.seoTitle"), _("mobilePromo.seoDesc"),('mobilePromo.seoKeywords'));
			Canonical.set("/mobilepromo");

			this._appendCloseButton();

			return this;
		}

		deactivate() {
			if (!this.isActive()) { return this; }

			this._removeCloseButton();
			this._clearForm();

			super.deactivate();
		}

		_widthChangeStart(e) {
			if (e.data.newWidth < 2) { this.deactivate(); }
		}

		setState(state) {
			this["mobilepromo" in state ? "activate" : "deactivate"]();
		}

		getState() {
			return { mobilepromo: 1 };
		}

		handleEvent(e) {
			if (e.type == "submit") {
				e.preventDefault();
				this._send();
				return;
			}

			if (this._sendBtn && (this._sendBtn === e.target || this._sendBtn.contains(e.target))) {
				e.preventDefault();
				this._getCaptcha();
				this._form?.classList.remove("hidden");
				this._successCont.classList.add("hidden");
				this._phoneInput.focus();
			}
			else if (this._cancelBtn === e.target) {
				e.preventDefault();
				this._clearForm();
				this._form?.classList.add("hidden");
			}
		}

		_clearForm() {
			this._setErrorMessage("","phone");
			this._setErrorMessage("","captcha");
			if (this._form) {
				this._phoneInput.value = "";
				this._captchaInput.value = "";
			}
		}

		_build() {
			// uvodni kecy
			const intro = node("div", { className: "intro" });
			intro.innerHTML = "<h1>Mapy.com</h1>"
			+ '<img src="/img/mobile/logo.png" />'
			+ "<h2>" + _("mobilePromo.introLine") + "</h2>";
			this._dom.container.appendChild(intro);

			if (!CONFIG.isMapyczApp) {
				const sticky = node("div", { className: "sticky" });
				const apps = createMobileAppButtons();

				sticky.appendChild(apps);

				this._sendBtn = node("button", {className:"show-form" });
				const sendCont = node("span", { innerHTML: _("mobilePromo.freeSend") });
				this._sendBtn.appendChild(sendCont);
				sticky.appendChild(this._sendBtn);

				this._form = node("form");

				this._form.innerHTML = "<label>" + _("mobilePromo.form.phone") + "</label><input type='tel' placeholder=\"777 888 999\" />"
					+ "<label>" + _("mobilePromo.form.code") + "</label><img src=\"\" /><input type='text' class=\"code\" placeholder=\"" + _("mobilePromo.form.codePlaceholder") + "\" />"
					+ "<button class='submit'>" + _("mobilePromo.form.send") + "</button><button type='button' class='cancel'>" + _("cancel") + "</button>"
					+ "<p class=\"form-error phone\"></p>"
					+ "<p class=\"form-error captcha\"></p>";
				this._form.classList.add("hidden");
				sticky.appendChild(this._form);

				this._phoneInput = this._form.querySelectorAll("input")[0];
				this._phoneInputErr = this._form.parentNode.querySelector(".form-error.phone");
				this._captchaInput = this._form.querySelectorAll("input")[1];
				this._captchaInputErr = this._form.parentNode.querySelector(".form-error.captcha");
				this._captchaImage = this._form.querySelectorAll("img")[0];
				this._cancelBtn = this._form.querySelectorAll("button")[1];

				this._successCont = node("div", {className:"success", innerHTML: _("mobilePromo.success")});
				this._successCont.classList.add("hidden");
				this._form.appendChild(this._successCont);

				this._dom.container.append(sticky);
			}

			const features = node("div", { className: "features" });
			const langTable = [
				{ source: "cs", langs: ["cs", "sk"] },
				{ source: "en", langs: ["en", "de"] }
			];
			let lang;
			const curLang = CONFIG.defaultLang;

			langTable.every(function(i) {
				if (i.langs.indexOf(curLang) != -1) {
					lang = i.source;
				}
				else return true;
			});

			// def. nechame anglictinu
			if (!lang) {
				lang = "en";
			}

			SECTION_INDEXES_ORDER.forEach(i => {
				const section = node("div");

				section.appendChild(node("img", {
					src: `/img/mobile/${i}.png`,
				}));
				section.appendChild(node("h3", {}, _("mobilePromo.newFeaturesHeader" + i)));
				section.appendChild(node("p", {}, _("mobilePromo.newFeaturesDesc" + i)));

				features.appendChild(section);
			});

			this._dom.container.appendChild(features);

			this._form?.addEventListener("submit", this, false);
			this._sendBtn?.addEventListener("click", this, false);
			this._cancelBtn?.addEventListener("click", this, false);
		}

		_clear() {
			this._form?.removeEventListener("submit", this, false);
			this._sendBtn?.removeEventListener("click", this, false);
			this._cancelBtn?.removeEventListener("click", this, false);
			this._dom.container.innerHTML = "";
		}

		_getCaptcha() {
			this._hash = null;

			Mapy.Util.request("/createCaptcha", {
				type: "text",
				headers: {
					"accept": "application/json"
				}
			}).promise.then(data => {
				this._captchaCreateResponse(data);
			}, e => {
				this._captchaCreateResponse(e);
			});
		}

		_captchaCreateResponse(response) {
			if (response.status != 200 || !response.data || response.data === "") {
				this._setErrorMessage(_("mobilePromo.errorCaptcha"),"captcha");
				return;
			}
			this._captchaInput.value = "";
			this._hash = response.data;
			this._captchaImage.src = "/getCaptchaImage?hash=" + this._hash;
		}

		_setErrorMessage(message,target) {
			if (this._form) {
				if(target == "captcha") {
					this._captchaInputErr.innerHTML = message;
					this._captchaInput.style.borderColor = message ? "#c60000" : "";
				} else if(target == "phone") {
					this._phoneInputErr.innerHTML = message;
					this._phoneInput.style.borderColor = message ? "#c60000" : "";
				}
			}
		}

		_send(phone, captcha) {
			const requestData = {
				code: this._captchaInput.value,
				hash: this._hash,
				phoneNumber: this._phoneInput.value
			};
			this._setErrorMessage("","phone");
			Mapy.getComponent("logger").log("click", {
				text: "Poslat"
			});

			Mapy.Util.request("/sendmsgPromo", {
				method:"post",
				json: requestData,
				headers: {
					"accept": "application/json"
				},
			}).promise.then(data => {
				this._sendDataResponse(data);
			}, e => {
				this._sendDataResponse(e);
			});
		}

		_sendDataResponse(data) {
			if (!data && data.status != 200) {
				this._setErrorMessage(_("mobilePromo.errorNotSent"),"phone");
				return;
			}
			const status = data.data.status;

			this._setErrorMessage("","phone");
			this._setErrorMessage("","captcha");
			switch (status) {
				case 200:
					this._setErrorMessage("","captcha");
					this._successCont.classList.remove("hidden");
					Mapy.getComponent("logger").log("sms-leti");
				break;
				case 400:
					this._setErrorMessage(_("mobilePromo.errorCode"),"captcha");
					this._getCaptcha();
				break;
				case 404:
						this._setErrorMessage("","captcha");
					this._setErrorMessage(_("mobilePromo.errorNumber"),"phone");
					this._getCaptcha();
				break;
				default:
						this._setErrorMessage("","captcha");
					this._setErrorMessage(_("mobilePromo.errorNotSent"),"phone");
					this._getCaptcha();
				break;
			}
		}

		_appendCloseButton() {
			if (!CONFIG.inFrame && !CONFIG.isMapyczApp) {
				var node = Mapy.getComponent("layout").getScrollNode();
				node.parentNode.insertBefore(this._dom.closeButton, node);
			}
		}
	}
};
